import type { FC } from 'react';

interface Props {
  className?: string;
}

const FireplaceIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 3v4m0 0c-1.5 0-3 1-3 3s1.5 3 3 3 3-1 3-3-1.5-3-3-3zm0 10c-2 0-4 1.5-4 4v4h8v-4c0-2.5-2-4-4-4z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 17h8M6 21h12" />
    </svg>
  );
};

export default FireplaceIcon;
